import { render, staticRenderFns } from "./AlertAuthError.vue?vue&type=template&id=99f9c6b0&scoped=true&"
import script from "./AlertAuthError.vue?vue&type=script&lang=js&"
export * from "./AlertAuthError.vue?vue&type=script&lang=js&"
import style0 from "./AlertAuthError.vue?vue&type=style&index=0&id=99f9c6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9c6b0",
  null
  
)

export default component.exports